import { create } from './Create/Create.i18n.ja'

export const tankHistories = {
  create,
}
